export class AnomalyGraphData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataPoints",
            "baseName": "dataPoints",
            "type": "Array<AnomalyDataPoint>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AnomalyGraphData.attributeTypeMap;
    }
    constructor() {
    }
}
